<template>
  <div id="app">
    <Tabs></Tabs>
    <!-- <img class="banner" :src="this.url.imgUrl + banner" alt="" />
    <Notice></Notice> -->
    <div class="content_box">
      <div class="content">
        <!-- 导航 -->
        <div class="nav_box">
          <!-- 一级导航 -->
          <div class="one_box">
            <div>{{ one_name }}</div>
            <!-- <el-select v-model="value" placeholder="切换考试">
              <el-option
                v-for="item in one_nav"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->

            <div class="choose_btn" @click="dialogVisible = true">
              切换考试
              <img src="../../../assets/img/xuanze.png" alt="" />
            </div>
          </div>
          <!-- 二级导航 -->
          <div class="two_box">
            <div class="two_left">专业科目</div>
            <div class="two_right">
              <!-- :class="[choose_two == item.chapter_category_id ? 'major' : '']" -->
              <div
                class="major_el"
                :class="{ major: arr.indexOf(index) > -1 }"
                v-for="(item, index) in two_nav"
                :key="item.chapter_category_id"
                @click="cutList(item, index)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="card_box">
          <Menu></Menu>
          <img src="../../../assets/img/everyday.png" alt="" />
          <div>
            每次将为您随机抽取
            <p>20道</p>
            易错题型进行练习
          </div>
          <el-button type="primary" @click="reday">开始练习</el-button>
        </div>
      </div>
    </div>
    <!-- dialog框 -->
    <!-- dialog框 -->
    <el-dialog title="请选择专业科目" :visible.sync="dialogVisible" width="33%">
      <!-- <span>这是一段信息</span> -->
      <div class="chapter_category_box">
        <div
          class="chapter_category_el"
          v-for="item in one_nav"
          :key="item.id"
          @click="choose_major(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibles"
      :before-close="handleClose"
      width="30%"
    >
      <span>{{ msg }}</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisibles = false">取 消</el-button> -->
        <el-button type="primary" @click="goback"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <Foot></Foot>
  </div>
</template>

<script>
import api from "@/api/api";
export default {
  data() {
    return {
      dialogVisibles:false,
      msg:'',
      banner: "/assets/img/infomation.jpg", //banner
      dialogVisible: false, //弹窗
      one_nav: [], //一级导航
      one_name: "", //一级导航名字
      chapter_category: "", // 一级导航id
      two_nav: [], //二级导航
      two_name: "", //二级导航名字
      choose_two: "", // 二级导航默认选中
      arr: [], // 多选数组
      strs: [],
    };
  },

  mounted() {},

  methods: {
    //   获取一级章节分类
    getOneChapter() {
      api.chapter_category().then((res) => {
        // // console.log("一级分类", res);
        if (parseInt(res.data.code) == 1) {
          this.one_nav = res.data.data.list;
          // this.one_name = res.data.data.list[0].name;
          // this.getTwoChapter(res.data.data.list[0].id);

          if (sessionStorage.getItem("chapterName")) {
            this.one_name = sessionStorage.getItem("chapterName");
          } else {
            this.one_name = res.data.data.list[0].name;
          }
          if (sessionStorage.getItem("chapterId")) {
            this.getTwoChapter(sessionStorage.getItem("chapterId"));
            this.chapter_category = sessionStorage.getItem("chapterId");
          } else {
            this.getTwoChapter(res.data.data.list[0].id);
            this.chapter_category = res.data.data.list[0].id;
          }
        }
      });
    },
    // 点击一级导航切换章节
    choose_major(el) {
      // console.log("章节", el);
      this.getTwoChapter(el.id);
      this.one_name = el.name;
      sessionStorage.setItem("chapterId", el.id);
      sessionStorage.setItem("chapterName", el.name);
      this.dialogVisible = false;
      this.chapter_category = el.id;
    },
    //   获取一级章节分类
    getTwoChapter(id) {
      var data = {
        chapter_category: id,
        chapter_category_id: id,
      };
      api.my_course_chapcate(data).then((res) => {
        // // console.log("二级分类", res);
        if (parseInt(res.data.code) == 1) {
          this.two_nav = res.data.data.list;
          // // console.log(this.two_nav);
          this.chapters_list = res.data.data.list[0].chapters;
          this.choose_two = this.two_nav[0].chapter_category_id;
          // // console.log(this.two_nav[0].chapter_category_id);
        } else if (res.data.code == 401) {
          this.$message.error({
            message: "请先登录!",
            duration: "2000",
          });
          this.$router.push({
            name: "Login",
          });
        } else {
          this.msg = res.data.msg
          this.dialogVisibles = true
        }
      });
    },
    goback(){
            this.$router.go(-1);
    },
    handleClose(){
      this.$router.go(-1);
    },
    // 点击二级导航切换列表
    cutList(el, index) {
      console.log(el)
      // console.log("二级导航点击", el);
      this.chapters_list = el.chapters;
      this.choose_two = el.id;
      let arrindex = this.arr.indexOf(index);
      if (arrindex > -1) {
        this.arr.splice(arrindex, 1);
        this.strs.splice(arrindex, 1);
      } else {
        this.arr.push(index);
        this.strs.push(el.id);
      }
      // console.log(this.strs);
    },
    // 开始练习
    reday() {
      // // console.log(this.strs.length);
      // 开始练习前先清除本地存储的用户答案数据
      sessionStorage.removeItem("user");
      if (this.strs.length == 0) {
        this.$message.error({
          duration: 2000,
          message: "至少选择一个专业科目!",
        });
        return false;
      } else {
        this.$router.push({
          name: "Practice",
          params: {
            is_pageid: 9,
            chapter_id: this.chapter_category,
            three_chaptercate_id: this.strs.join(","),
          },
        });
      }
    },
  },
  created() {
    this.getOneChapter();
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 400px;
}
// 内容区
.content_box {
  width: 100%;
  background: #f5f5f5;
  .content {
    width: 1200px;
    margin: auto;
    overflow: hidden;
    //   导航
   .nav_box {
      width: 1160px;
      // height: 170px;
      padding:0 20px;
      background: #fff;
      border-radius: 6px;
      margin: 30px 0;
      overflow: hidden;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      //   一级导航
      .one_box {
        width: 100%;
        display: flex;
        position: relative;
        align-items: center;
        margin: 24px 0 26px;
        div {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #222222;
        }
        .select_option {
          position: relative;
          margin-left: 12px;
          /deep/.el-select {
            width: 96px;
            height: 26px;
            background: #3e7eff;
            border-radius: 13px;
            .el-input__inner {
              width: 96px;
              height: 26px;
              // color: red;
              color: rgba(0, 0, 0, 0);
              background: #3e7eff;
              border-radius: 13px;
              padding: 0;
              display: flex;
              justify-content: space-between;
              border: none;
              background-image: url("../../../assets/img/qiehuan.png");
              background-repeat: no-repeat;
              background-size: 13px 12px;
              background-position-x: 72px;
              background-position-y: 7px;
              // display: none;
            }
            .el-input__inner::placeholder {
              color: rgba(0, 0, 0, 0);
              padding-left: 11px;
            }
            .el-input__suffix-inner {
              display: none;
            }
          }

          p {
            position: absolute;
            top: 6px;
            left: 11px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #fff;
            // z-index: -1;
            // z-index: 999;
          }
        }
        .choose_btn {
          width: 81px;
          height: 23px;
          border: 1px solid #3e7eff;
          border-radius: 11px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #3e7eff;
          line-height: 23px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
          cursor: pointer;
          img {
            width: 12px;
            height: 8px;
            margin-left: 3px;
          }
        }
      }
      //   二级导航
      .two_box {
        width: 100%;
        // min-height: 65px;
        display: flex;
        .two_left {
          width: 60px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #484848;
          padding: 7px 0;
          // padding-top: 7px;
        }
        .two_right {
          width: 997px;
          margin-left: 49px;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 18px;
          .major_el {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #202b3a;
            text-align: center;
            padding: 5px 19px;
            cursor: pointer;
          }
          .major {
            color: #3e7eff;
            // background: #3e7eff;
            border-radius: 18px;
            // max-height: 30px;
            // padding-bottom: 7px;
          }
        }
      }
    }
    //   章节
    .chapter_box {
      width: 1180px;
      height: 70px;
      background: #fff;
      padding-left: 20px;
      margin: 30px 0 20px;
      border-radius: 6px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      p {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #222222;
      }
      .btn {
        width: 81px;
        height: 23px;
        border: 1px solid #3e7eff;
        border-radius: 11px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #3e7eff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        img {
          width: 12px;
          height: 8px;
          margin-left: 4px;
        }
      }
    }
    .card_box {
      width: 100%;
      height: 740px;
      background: #fff;
      border-radius: 0 0 6px 6px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-bottom: 225px;
      border-radius: 6px;
      img {
        width: 460px;
        // height: 410px;
        margin: 48px 0 31px;
      }
      div {
        display: flex;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
        p {
          color: #3e7eff;
        }
      }
      .el-button {
        width: 200px;
        height: 50px;
        background: #3e7eff;
        border-radius: 6px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-top: 12px;
      }
    }
  }
}
.one_box::after{
  content: '';
  display: block;
  height: 1px;
  width: 100%;
  background: #f5f5f5;
  position: absolute;
  bottom: -14px;
  left: 0;
}
.chapter_category_box {
  width: 100%;
  display: flex;
  .chapter_category_el {
    cursor: pointer;
    margin-right: 30px;
  }
  .chapter_category_el:hover {
    color: #3e7eff;
  }
}
</style>
